const isAuthenticatedGuard = (to, from, next) => {
    if (!localStorage.getItem('accessToken')) {
        next({
          path: '/login',
          replace: true
        })
    } else {
        next();
    }
}

export default isAuthenticatedGuard